import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: 'http://db86a59c2207494a86fc343e5436ec35@91.214.191.8:3002/1',  // expose DSN via env var
  tracesSampleRate: 0,
  sendDefaultPii: true,
});
